<script>
import InvoicesApi from "@/services/invoices-api";

export default {
  components: { },
      props: {
        status: Number,
        customerId:Number,
        start:{
          type:String,
          default:null
        },
        end:{
          type:String,
          default:null
        }
      },

    mounted(){
      this.role=sessionStorage.getItem("userr");
      this.getInvoices();
    },
    data (){
        return {
            role:null,
            invoicesList:[],
            pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
            isTableLoading:false,
            tableFieldsForSupplier: [
              { key:"date", label: "Date",thClass:"align-middle", tdClass:"align-middle" },
              
              { key:"number", label: "Numéro", thClass:"align-middle", tdClass:"font-weight-bold text-info align-middle"},
              
              { key:"customer", label: "Client", thClass:"align-middle", tdClass:"font-weight-bold align-middle"},

              { key:"amountTaxIncl", label: "Total TTC", thClass:"align-middle", tdClass:"align-middle"},

              { key:"download", label: "", thClass:"align-middle", tdClass:"font-weight-bold align-middle text-right"},
              
              ],

              exportInvoicesInProgress : false,

              isDownloadInProgress: false,
        }
    },

    computed: {
      tableFieldsForCustomer() {
          return this.tableFieldsForSupplier.filter(f => f.key !== "customer" );
        },
    },

    methods: {

    getInvoices() {
      this.isTableLoading = true;
      InvoicesApi.getAvoirs(this.pagemodel.currentPage, this.pagemodel.perPage,this.customerId,this.status,this.start,this.end)
        .then(result => {
          this.invoicesList = result.list
          this.pagemodel.totalRows = result.total;
          this.pagemodel.currentPage = result.page;
          this.pagemodel.perPage = result.pageSize;
          this.pagemodel.pageSize = result.pageSize;
        })
        .finally(() => {
        this.isTableLoading = false;
      })
    },

    statusToColor(status) {
      switch(status) {
        case 0: return 'warning';
        case 1: return 'success';
        case 2: return 'info'
        case 3: return 'danger';
        default: return '';
      }
    },

    statusToLabel(status) {
      switch(status) {
        case 0: return 'unpaid';
        case 1: return 'inprogress';
        case 2: return 'paid';
        default: return '';
      }
    },

    TypeToLabel(status) {
      switch(status) {
        case 0: return 'creditBill';
        case 1: return 'bill';
        default: return '';
      }
    },

    exportInvoicesListExcel: function() {
        return InvoicesApi.export(this.pagemodel.currentPage, this.pagemodel.perPage,this.customerId,this.status,this.start,this.end)
    },

    download(id){
      this.isDownloadInProgress=true;
      InvoicesApi.downloadAvoir(id)
      .finally(() => {
        this.isDownloadInProgress = false;
      })
    },

    },
    watch: {
        status : function(){
          this.getInvoices()
        },
        
        customerId: function(){
          this.getInvoices()
        },

        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getInvoices()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getInvoices()

          }
        },
    }
};
</script>
<template>
<div>

      <div class="table-responsive mt-3">        
        <b-table 
        :busy="isTableLoading"
        :striped="true"
        :small="false"
        :hover="true"
        :items="invoicesList"
        :fields="role==0 ? tableFieldsForCustomer : tableFieldsForSupplier"
        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:table-busy>
          <div class="text-center my-2">
              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </template>



        <template v-slot:cell(download)="{item}"> 


          <b-button class="ml-2" title="Ouvrir"  size="sm"   variant="outline-dark" @click="download(item.id)" :disabled="isDownloadInProgress">
                <b-spinner v-if="isDownloadInProgress" small class="mr-0 mr-sm-2" ></b-spinner>
                <i v-if="!isDownloadInProgress" class="fas fa-download font-size-16 align-middle mr-0 mr-sm-2"></i>
                <span class="d-none font-weight-bold d-sm-inline">Télécharger</span>
          </b-button> 

          
        </template>

    


        </b-table>
        <span v-if="!isTableLoading && invoicesList && !invoicesList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("invoicesMenu.list.empty")}}</span>
    </div>

    <!-- Pagination -->
    <div class="row pt-3 mb-sm-4">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getInvoices()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getInvoices()" :disabled="isTableLoading"></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->


</div>
</template>                                                                                                                                                                                                                                                                                                                  